import { useState } from 'react'

import { LoginStrategy } from './types'

export const useLoginStrategy = (strategy: LoginStrategy | null) => {
  const [currentStepId, setCurrentStepId] = useState<string>(
    strategy?.getInitialStep() || 'default'
  )
  const [stepData, setStepData] = useState<Record<string, unknown>>({})

  const currentStep = strategy?.steps.find((step) => step.id === currentStepId)

  const goToStep = (stepId: string) => {
    setCurrentStepId(stepId)
  }

  const goToNextStep = () => {
    if (!strategy) return
    const currentIndex = strategy.steps.findIndex((step) => step.id === currentStepId)
    if (currentIndex < strategy.steps.length - 1) {
      setCurrentStepId(strategy.steps[currentIndex + 1].id)
    }
  }

  const goToPreviousStep = () => {
    if (!strategy) return
    const currentIndex = strategy.steps.findIndex((step) => step.id === currentStepId)
    if (currentIndex > 0) {
      setCurrentStepId(strategy.steps[currentIndex - 1].id)
    }
  }

  const updateStepData = (data: Record<string, unknown>) => {
    setStepData((prev) => ({ ...prev, ...data }))
  }

  const resetStrategy = () => {
    setCurrentStepId(strategy?.getInitialStep() || 'default')
    setStepData({})
  }

  return {
    currentStep,
    currentStepId,
    stepData,
    goToStep,
    goToNextStep,
    goToPreviousStep,
    updateStepData,
    resetStrategy
  }
}
